import React from 'react';
import {Button, Form, Input, message, Modal, Table} from 'antd';
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl-context";
import {getJoinStatePlayer, personTrainingNotice} from "../../../modules/training/action";

const defaultProps = {
    value: {},
    visible: false,
    onClose: () => {
    },
};

const {confirm} = Modal;

class TestModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [], // Check here to configure the default column
            loading: false,
            pushContent: '',
            page: 1,
            size: 25,
        };
    }

    componentWillMount() {
        this.requestPassPlayer();
    }

    requestPassPlayer = () => {
        let {getJoinStatePlayer} = this.props;
        let {trainingId} = this.props.match.params;
        getJoinStatePlayer({trainingId: window.atob(trainingId), state: "PASS", size: 10000, page: 1});
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({
            selectedRowKeys: selectedRowKeys
        });
    };

    onInputChange = (e) =>{
        console.log(e.currentTarget.value)
        this.setState({
            pushContent: e.currentTarget.value
        })
    }

    // 全部推送
    onBtnAllPush = async () =>{
        let _this = this
        const {pushContent} = this.state;
        if(!pushContent || !pushContent.trim()){
            message.error('请输入要推送的内容');
            document.getElementById("inputPushContent").focus();
        }else{
            confirm({
                content: '确认要向所有用户推送消息吗?',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    const { statePlayerInfo } = _this.props;
                    let userIds = statePlayerInfo.data.map(v => v.id.split('_')[0]);
                    _this.doTrainingNotice(pushContent, userIds);
                },
                onCancel() {}
            });
        }
    }

    // 根据下方选择的用户推送
    onBtnSelectPush = async () =>{
        let _this = this;
        const {pushContent,selectedRowKeys} = this.state;

        if(selectedRowKeys && selectedRowKeys.length < 1 ){
            message.error("未选中推送用户")
        }else if(!pushContent || !pushContent.trim()){
            message.error('请输入要推送的内容');
            document.getElementById("inputPushContent").focus();
        }else{
            const { statePlayerInfo } = this.props;
            let userIds = statePlayerInfo.data.filter((v, i) => selectedRowKeys.includes(i)).map(v=>v.id.split('_')[0]);
            confirm({
                content: '确认要向已选用户推送消息吗?',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    _this.doTrainingNotice(pushContent, userIds);
                },
                onCancel() {
                },

            });
        }
    }

    doTrainingNotice= async (pushContent, userIds) => {
        const {personTrainingNotice} = this.props;
        let {trainingId} = this.props.match.params;
        message.success('消息推送成功');
        personTrainingNotice({notictTitle: pushContent, noticeContent: pushContent, trainingId: window.atob(trainingId), userIds: userIds});
    }

    onPageChangeEvent = async (current, pageSize) => {
        this.state.page = current;
        let {size} = this.state;
        let {getJoinStatePlayer} = this.props;
        let {trainingId} = this.props.match.params;
        await getJoinStatePlayer({trainingId: window.atob(trainingId),state:"PASS", size:size, page:current});
        this.setState({
            page: current,
            size: pageSize,
            selectedRowKeys: []
        });
    }

    getTableColumns = () => {
        return (
            [{
                title: 'ID',
                dataIndex: 'id',
                align: 'center',
                key: 'id',
            }, {
                title: '用户ID',
                dataIndex: 'exhibitionId',
                align: 'center',
                key: 'exhibitionId',

            }, {
                title: '用户名称',
                dataIndex: 'userName',
                align: 'center',
                key: 'userName',
            }]
        )
    }



    render() {
        let { visible, statePlayerInfo} = this.props
        const {page, size, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        return (
            <Modal
                visible={visible}
                title="推送"
                onCancel={this.props.onClose}
                footer={null}
            >
                <div>
                    <card>
                        <Input id={'inputPushContent'} placeholder="请输入要推送的内容" style={{widths: 'auto'}}
                               onChange={(e) => this.onInputChange(e)}/>
                    </card>
                    <card>
                        <div>
                            <div style={{marginBottom: 16, marginTop: 16}}>
                                <Button onClick={() => this.onBtnAllPush()} style={{marginRight: 16}}>
                                    全部推送
                                </Button>
                                <Button type="primary" onClick={() => this.onBtnSelectPush()}>
                                    根据下方选择的用户推送
                                </Button>
                            </div>
                            <Table rowSelection={rowSelection} columns={this.getTableColumns()}
                                   dataSource={statePlayerInfo.data ? statePlayerInfo.data : []}
                                   pagination={{
                                       total: statePlayerInfo.total ? statePlayerInfo.total : 0,
                                       current: page,
                                       pageSize: size,
                                       onChange: this.onPageChangeEvent,
                                       showTotal:(total)=>{
                                           return `总计 ${total}条数据`;
                                       }
                                   }}
                            />
                        </div>
                    </card>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.viewTraining,
    }
};
const mapDispatchToProps = ({
    getJoinStatePlayer, personTrainingNotice
});
TestModal.defaultProps = defaultProps;
export default connect(
    mapStateToProps, mapDispatchToProps,
)(injectIntl(Form.create()(TestModal)));
